import React, { useEffect, useState } from "react";
import { t } from "ttag";
import assetsService from "../../../services/assetsService";
import packageJson from "../../../../package.json";
import { useStoreState } from "../../../models/RootStore";
import styles from "./DeviceConfigSideBar.module.css";

interface IDeviceDetails {
  name?: string;
  serial?: string;
  ip?: string;
  isConnected?: boolean;
  firmwareVersion?: string;
  itcVersion?: any;
  protocolVersion?: any;
  deviceType?: any;
  type?: any;
  localAddress?: string;
}

interface IDeviceConfigSideBarProps {
  getDeviceDetails: () => Promise<IDeviceDetails | null>;
}

const DeviceConfigSideBar: React.FC<IDeviceConfigSideBarProps> = ({ getDeviceDetails }) => {
  const [device, setDevice] = useState<IDeviceDetails | null>(null);
  const getDevicesTypesNames = useStoreState((state) => state.getDevicesTypesNames);

  useEffect(() => {
    const fetchDeviceDetails = async () => {
      try {
        const deviceData = await getDeviceDetails();
        setDevice(deviceData);
      } catch (error) {
        console.error("Failed to fetch device details:", error);
      }
    };

    fetchDeviceDetails();
  }, [getDeviceDetails]);

  if (!device) {
    return null;
  }

  const deviceTypeName = getDevicesTypesNames(device.deviceType ?? 1, device.type ?? 0);

  return (
    <aside className={styles.sidebar}>
      <div className={styles.header}>
        <img className={styles.logo} alt="Cool Automation" src={assetsService.getResourcePath("logo.png")} />
      </div>

      <div className={styles.deviceInfo}>
        <div className={styles.deviceTitle}>{deviceTypeName}</div>

        <div className={styles.infoRow}>
          <span className={styles.label}>{t`SN:`}</span>
          <span className={styles.value}>{device.serial || "N/A"}</span>
        </div>

        <div className={styles.infoRow}>
           <span className={styles.label}>{t`Local IP:`}</span>
          <span className={styles.value}>{device.localAddress || "N/A"}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.label}>{t`Cloud Status:`}</span>
          <span className={styles.value}>{device.isConnected ? "OK" : "X"}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.label}>{t`FW Ver:`}</span>
          <span className={styles.value}>{device.firmwareVersion || "N/A"}</span>
        </div>

        <div className={styles.infoRow}>
          <span className={styles.label}>{t`Protocol Ver:`}</span>
          <span className={styles.value}>{device.itcVersion ?? device.protocolVersion ?? "N/A"}</span>
        </div>
      </div>

      <div className={styles.footer}>
        <span className={styles.version}>{t`Version`} {packageJson.version}</span>
      </div>
    </aside>
  );
};

export default DeviceConfigSideBar;
